import Immutable from 'immutable';
import {
  GET_ITEM_CONDITIONS,
  FLAG_GETTING_ITEM_CONDITIONS,
  CLEAR_ITEM_CONDITIONS,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  regular: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  special: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ITEM_CONDITIONS:
      return state.setIn(
        [action.payload.key, 'content'],
        Immutable.Map(action.payload.data),
      );
    case FLAG_GETTING_ITEM_CONDITIONS:
      return state.setIn([action.payload.key, 'loading'], action.payload.flag);
    case CLEAR_ITEM_CONDITIONS:
      return state.setIn(
        [action.payload.key, 'content'],
        Immutable.Map(COLLECTION_SHAPE),
      );
    default:
      return state;
  }
};
